import * as types from "./types";
import { getUserKey } from "./utils";
import moment from "moment";

export const setKey = (
  key,
  value,
  {
    userScope = true,
    transient = false,
    expires = false, // In Seconds - note: this isn't going to actually expire yet
    sessionScope = false
  } = {}
) => (dispatch, getState) => {
  const expireOn = expires
    ? moment()
        .add(expires, "seconds")
        .utc()
        .format()
    : false;
  dispatch({
    type: types.STORAGE_SET_KEY,
    key: getUserKey(getState(), key, userScope, sessionScope),
    transient,
    data: { value, expires: expireOn }
  });
  return Promise.resolve();
};

export const deleteKey = (
  key,
  { userScope = true, sessionScope = false } = {}
) => (dispatch, getState) => {
  dispatch({
    type: types.STORAGE_DELETE_KEY,
    key: getUserKey(getState(), key, userScope, sessionScope)
  });
};

// TODO we need this for now... but I don't like it
const saveLegacyUserOnboardingSeen = () => {
  const onboarding = Fraction.Helpers.getUserData("onboarding") || {};
  onboarding.welcome = Fraction.User.sessionId;
  Fraction.Helpers.saveUserData("onboarding", onboarding);
};

export const setHasSeenWelcomeOnboarding = () => (dispatch, getState) => {
  dispatch(setKey("hasSeenWelcomOnboarding", true));
  saveLegacyUserOnboardingSeen();
};
